import { KnownBaleChamberType } from '@internal/utils/machine/KnownBalerChamberType';

export const FilterableBaleChamberOption = {
    FIXED_CHAMBER: KnownBaleChamberType.FIXED_CHAMBER.toString(),
    VARIABLE_CHAMBER: KnownBaleChamberType.VARIABLE_CHAMBER.toString(),
    SEMI_VARIABLE_CHAMBER:
        KnownBaleChamberType.SEMI_VARIABLE_CHAMBER.toString(),
};
